export const integerInputPattern = /^\d*$/
export const decimalInputPattern = /^\d*(?:\.\d*)?$/

export const integerInputHtmlPattern = '[0-9]*'
export const decimalInputHtmlPattern = '[0-9]*[.]?[0-9]*'
